import { actionCreators, asyncAction } from 'lib/actionCreators'

export const guestJobsList = asyncAction('candidate/JOBS_LIST')
export const guestNewJobsList = asyncAction('candidate/NEW_JOBS_LIST')
export const guestJobToFavorite = asyncAction('candidate/ADD_JOB_TO_FAVORITE')
export const guestCampaignsList = asyncAction('guest/CAMPAIGNS_LIST')
export const removeCurrentCampaign = actionCreators('guest/CURRENT_CAMPAIGN_REMOVE')
